<template>
  <div class="billing-container">
    <h4 class="title">{{ $t('titles.billing')}}</h4>
    <table class="billing-table">
      <thead>
      <tr>
        <th>{{ $t('tables.type') }}</th>
        <th>{{ $t('tables.date') }}</th>
        <th>{{ $t('tables.verification') }}</th>
        <th>{{ $t('tables.price') }}</th>
      </tr>
      </thead>
      <tbody>
        <tr v-for="payment in payments" :key="payment.id">
          <td>
            {{ payment.membershipType ? payment.membershipType.name : "-" }}
          </td>
          <td>{{formatDate(payment.paymentDate)}}</td>
          <td><span v-if="payment.receipt">{{payment.receipt.number}}</span></td>
          <td>{{ $n(payment.amount, `${branch}_currency`)}}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  components: {

  },
  data () {
    return {
      payments: []
    }
  },
  computed: {
    branch() {
      return process.env.FG_APP_BRANCH
    },
    membership() {
      return this.$store.getters.currentUser && this.$store.getters.currentUser.membership
    }
  },
  mounted () {
    this.$store.dispatch('getUserPayments')
      .then(response => {
        this.payments = response.payments.data
      })
  }
}
</script>


<style lang="scss" scoped>
.billing-container{
  width: 100%;
  margin-top: 30px;

  .billing-table {
  border-collapse: collapse;
  border-spacing: 0;
  //font-family: $secondary-font-family;
  //font-size: 0.7rem;
  width: 100%;
    thead th {
      padding: 20px 0;
      text-align: left;
      font-weight: normal;
      //text-shadow: 1px 1px 1px $white;
      //// font-size: 0.875rem;
      &:first-child {
        padding-left: 0;
      }
      &:last-child {
        text-align: right;
      }
    }
    tbody td {
      border-top: solid 1px #333A41;
      font-size: 1rem;
      //color: $body-color;
      padding: 13px 0;
      //text-shadow: 1px 1px 1px #fff;
      &:first-child {
        //font-weight: bold;
        padding-left: 0;
        // font-size: 0.875rem;
      }
      &:last-child {
        text-align: right;
      }
    }
  }
}
</style>
